export default __webpack_public_path__ + "static/media/vision.fc90eb9e.png";